export default "__VITE_ASSET__23c04c0e__"